import axios from "axios";

const API = axios.create({
  baseURL: "https://crm.jobhubs.in/api"
});

// login
export const loginUser = (data) => API.post("/login", data);

// Companies
export const getCompanies = () => API.get("/companies");
export const createCompany = (data) => API.post("/companies", data);
export const updateCompany = (id, data) => API.put(`/companies/${id}`, data);
export const deleteCompany = (id) => API.delete(`/companies/${id}`);

// Jobs
export const getJobs = () => API.get("/jobs");
export const createJob = (data) => API.post("/jobs", data);
export const updateJob = (id, data) => API.put(`/jobs/${id}`, data);
export const deleteJob = (id) => API.delete(`/jobs/${id}`);

// Candidates
export const getCandidates = () => API.get("/candidates");
export const createCandidate = (data) => API.post("/candidates", data);
export const updateCandidate = (id, data) => API.put(`/candidates/${id}`, data);
export const deleteCandidate = (id) => API.delete(`/candidates/${id}`);
